// components/ClientPricesCsvDialog.js

import { useState } from 'react';

import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Stack,
} from '@mui/material';

import {
    UploadFile,
    Download,
    TableView,
} from '@mui/icons-material';

import axiosInstance from '../utils/axiosInstance';
import { useSnackbar } from '../contexts/SnackbarProvider';

const ClientPricesCsvDialog = ({ clientId }) => {

    const { showSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const [csvFile, setCsvFile] = useState(null);

    const [loading, setLoading] = useState(false);

    const handleDownloadCsv = async () => {
        try {

            const res = await axiosInstance.post(
                `/client/${clientId}/prices-download-csv`,
                {},
                {
                    responseType: 'blob',
                }
            );

            const url = window.URL.createObjectURL(
                new Blob([res.data])
            );

            const link = document.createElement('a');

            link.href = url;

            link.setAttribute(
                'download',
                'client_prices.csv'
            );

            document.body.appendChild(link);

            link.click();

            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (err) {

            console.error(err);

            showSnackbar(
                'CSV出力に失敗しました',
                'error'
            );

        }
    };

    const handleCsvUpload = async () => {

        try {

            if (!csvFile) {
                showSnackbar(
                    'CSVファイルを選択してください',
                    'warning'
                );
                return;
            }

            setLoading(true);

            const formData = new FormData();

            formData.append('csv', csvFile);

            const res = await axiosInstance.post(
                `/client/${clientId}/prices-upload-csv`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            showSnackbar(
                res.data.message || 'CSVを取り込みました',
                'success'
            );

            setOpen(false);

            window.location.reload();

        } catch (err) {

            console.error(err);

            showSnackbar(
                err?.response?.data?.message || 'CSV取込に失敗しました',
                'error'
            );

        } finally {

            setLoading(false);

        }
    };

    return (
        <>
            <Button
                variant="related-menu"
                onClick={() => setOpen(true)}
            >
                <TableView />
                価格CSV
            </Button>

            <Dialog
                open={open}
                onClose={() => {
                    setOpen(false);
                    setCsvFile(null);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    価格CSVの取込・出力
                </DialogTitle>

                <DialogContent>
                    <Stack spacing={2} mt={2}>

                        <Typography>
                            価格CSVの取込・出力を行えます。
                        </Typography>

                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                        >
                            <Button
                                variant="outlined"
                                startIcon={<Download />}
                                onClick={handleDownloadCsv}
                            >
                                CSV出力
                            </Button>

                            <Button
                                variant="contained"
                                component="label"
                                startIcon={<UploadFile />}
                            >
                                CSV選択

                                <input
                                    hidden
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) =>
                                        setCsvFile(
                                            e.target.files?.[0] || null
                                        )
                                    }
                                />
                            </Button>
                        </Stack>

                        {csvFile && (
                            <Typography variant="body2">
                                選択中:
                                {' '}
                                {csvFile.name}
                            </Typography>
                        )}

                    </Stack>
                </DialogContent>

                <DialogActions>

                    <Button
                        variant="contained"
                        onClick={handleCsvUpload}
                        disabled={!csvFile || loading}
                    >
                        {loading
                            ? 'アップロード中...'
                            : 'CSV取込'}
                    </Button>

                    <Button
                        onClick={() => {
                            setOpen(false);
                            setCsvFile(null);
                        }}
                    >
                        閉じる
                    </Button>

                </DialogActions>
            </Dialog>
        </>
    );
};

export default ClientPricesCsvDialog;